const messages = {
  title: 'Interna greška',
  description: 'Podaci za ovu stranicu ne mogu biti ispravno učitani.',
  backHomeButton: 'Nazad na kontrolnu tablu'
}

export default {
  messages
}
